import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalType } from 'src/app/enums/modal-type.enum';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  ModalType = ModalType;

  constructor(
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { type: ModalType; title: string; modalMessage: string; snackBarMessage: string }
  ) {}

  openSnackBar() {
    if (this.data.snackBarMessage) {
      this._snackBar.open(this.data.snackBarMessage, 'cerrar', { duration: 1000 });
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
